import { PDFLink } from './constants';

export const withPDFLink = (editor) => {
  const { isInline } = editor; // we can also normalize plugin data here

  editor.isInline = (element) => {
    return element?.type === PDFLink ? true : isInline(element);
  };

  return editor;
};
